import React, { Component } from 'react'
import { BsFileArrowUpFill, BsFileArrowDownFill, BsBoxSeam } from "react-icons/bs";
import { AiOutlineReload, AiOutlineSearch } from "react-icons/ai";
import "../../../css/general-style.css"
import '../../../css/table-responsive.css'
import "../../../css/inventory-style.css"
import '../../../css/dashboard.css'
import { v4 as uuidv4 } from 'uuid';
import { getValueCookie } from '../../../services/cookieService';
import { getInformationWithData } from '../../../services/CABE';
//import { getIndexElement } from '../../../functions/searchInObject'

import LoadingWindow from '../../../components/LoadingWindow';
import { HeaderHistoryPurchaseOrder, Item } from './Class';
import { getIndexElement, getIndexElement2 } from '../../../functions/searchInObject';
import { ItemDesc, OrderArray } from '../../../functions/generalFunctions';
import ExcelDocument from '../../../components/ExcelDocument';
import { getDateFromReports } from '../../../functions/dateFormat';
import { getDataSet, getDataSetHistoryPO } from '../../../functions/generateDataSetExcel';
//import { confirmCloseAlert } from '../../../functions/alerts';
import { Menu } from "../../../components/Menu/Menu";

export default class HistoryPurchaseOrderView extends Component {
    constructor(props) {
        super(props)

        this.ModalLoading = React.createRef();

    }

    state = {
        HeadTable: {
            Year: [],
            Months: [],
            Dates: [],
            GeneralHeaders: []
        },
        NotProcessData: [],
        Data: [],
        FilterData: [],
        order: false,
        Totals: []
    }
    searchHistoryPO = async e => {
        const searchValue = e.target.value
        let Filter = []
        if (searchValue === '') {
            Filter = this.state.Data
        } else {
            Filter = this.state.Data.filter((detail) => {
                if (
                    this.Contains(detail.ItemCode, searchValue) ||
                    this.Contains(detail.Description, searchValue) ||
                    this.Contains(detail.ProductLine, searchValue) ||
                    this.Contains(detail.VendorName, searchValue)
                ) {
                    return detail
                } else {
                    return null
                }
            })
        }
        await this.setState({ FilterData: Filter })
        await this.getTotals()
    }
    Contains(parametro, busqueda) {
        return parametro.toString().toLowerCase().includes(busqueda.toLocaleLowerCase())
    }
    OrderInformation(array, key, type) {
        const order = OrderArray(array, key, this.state.order)
        this.setState({ [type]: order, order: !this.state.order })

    }
    getTotals() {
        const temporal = this.state.FilterData
        let Totals = []
        for (const item of temporal) {
            for (const order of item.Detail) {

                const index = getIndexElement(Totals, 'NoOrder', order.NoOrder)
                if (index === -1) {
                    let add = {
                        NoOrder: order.NoOrder,
                        Total: (order.QuantityReceived === -1 || (!order.QuantityReceived) ? 0 : order.QuantityReceived)
                    }
                    Totals.push(add)
                } else {
                    Totals[index].Total += (order.QuantityReceived === -1 || (!order.QuantityReceived) ? 0 : order.QuantityReceived)
                }
            }
        }
        this.setState({ Totals: Totals })
    }


    async getPurchaseOrderHistory() {
        this.ModalLoading.current.showState(true);
        const data = {
            Start: document.getElementById('startPurchaseHistoryDate').value,
            End: document.getElementById('endPurchaseHistoryDate').value,
            idCompany: Number(getValueCookie('CompanyId'))
        }
        const result = await getInformationWithData('/purchase/get/detail/reportTime', data)
        if (result.status.code === 1) {
            this.setState({ NotProcessData: result.data })
            let header = new HeaderHistoryPurchaseOrder()
            let body = []
            for (const order of result.data) {
                header.addDates(order.OrderDate, order.OrderNo, order.Comment)
                const index = getIndexElement2(body, 'ItemCode', 'VendorNo', order.ItemCode, order.VendorNo)
                if (index === -1) {
                    let product = new Item(order.ItemCode, '', '', order.VendorNo, order.VendorName)
                    product.addOrder(order.OrderNo, order.QuantityReceived ? order.QuantityReceived : -1, order.OrderDate, order.QuantityOrdered ? order.QuantityOrdered : -1)
                    body.push(product)
                } else {
                    body[index].addOrder(order.OrderNo, order.QuantityReceived ? order.QuantityReceived : -1, order.OrderDate, order.QuantityOrdered ? order.QuantityOrdered : -1)
                }

            }

            for (let det of body) {

                for (const hed of header.Dates) {
                    const index = getIndexElement2(det.Detail, 'NoOrder', 'Date', hed.OrderNo, hed.Date)

                    if (index === -1) {
                        det.addSpace(hed.OrderNo, hed.Date)
                    }
                }
                det.orderDetail(header.GeneralHeaders)
            }

            body = await ItemDesc(body, 'Description', 'ItemCode', true)
            console.log(body)
            this.setState({ HeadTable: header, FilterData: body, Data: body })
        }
        await this.getTotals()
        this.ModalLoading.current.showState(false);
    }

    SelectOrderInHistory(array, title, order,parameter) {
        let key = ''
        switch (title) {
            case "Item Code":
                key = "ItemCode"
                break;
            case "Description":
                key = "Description"
                break;
            case "Primary Vendor":
                key = "VendorName"
                break;
            case "Product Line":
                key = "ProductLine"
                break;
            default:
                key = "PO"
                break;
        }

        if (key !== 'PO') {
            this.OrderInformation(array, key, order)
        } else {
            this.OrderByPurchaseOrders(array, title, order,parameter)
        }
    }

    async OrderByPurchaseOrders(array, orderNo, order,key) {
        let m = array.length
        const index = getIndexElement(array[0].Detail, 'NoOrder', orderNo)
        for (let i = 0; i < m; i++) {
            for (let j = 0; j < m - 1 - i; j++) {
                if (index !== -1) {
                    if (order) {
                        if (array[j].Detail[index][key] > array[j + 1].Detail[index][key]) {
                            [array[j], array[j + 1]] = await [array[j + 1], array[j]];
                        }
                    } else {
                        if (array[j].Detail[index][key] < array[j + 1].Detail[index][key]) {
                            [array[j], array[j + 1]] = await [array[j + 1], array[j]];
                        }

                    }
                }
            }
        }
        await this.setState({ FilterData: array, order: !order })
    }


    render() {
        const hasData = this.state.Data.length !== 0
        const labelStyle = { fontSize: '0.72rem', fontWeight: 700, color: '#64748B', textTransform: 'uppercase', letterSpacing: '0.06em', display: 'block', marginBottom: '5px' }
        const inputStyle = { borderRadius: '8px', border: '1.5px solid #E2E8F0', fontSize: '0.875rem', padding: '0.4rem 0.75rem', width: '100%' }

        return (
            // Old-shell page (App.js) — same ambient-container offset as PurchaseProcess.js: cancel
            // .container-fluid.generalContainer's 12px side gutters + 40px top padding, then re-apply
            // a top offset. Using 60px (not History KPI's 30px) — the fixed navbar renders taller than
            // 30px of clearance, so 30px left the hero sitting flush/too tight against it.
            <div className='dash-page' style={{ marginLeft: '-0.75rem', marginRight: '-0.75rem', position: 'relative', top: '-40px', paddingTop: '60px' }}>
                {this.props.showMenu && <Menu />}
                <LoadingWindow ref={this.ModalLoading} />

                {/* Hero */}
                <div style={{ background: 'linear-gradient(135deg, #0f172a 0%, #1e3a5f 50%, #2563EB 100%)', padding: '3rem 2rem', display: 'flex', alignItems: 'center', gap: '1rem', flexWrap: 'wrap' }}>
                    <div style={{ background: 'rgba(255,255,255,0.12)', borderRadius: '12px', padding: '0.75rem', display: 'flex' }}>
                        <BsBoxSeam style={{ color: 'white', fontSize: '1.75rem' }} />
                    </div>
                    <div style={{ flex: 1 }}>
                        <h1 style={{ color: 'white', fontWeight: 800, fontSize: '1.375rem', margin: 0 }}>History Purchase Orders Report</h1>
                        <p style={{ color: 'rgba(255,255,255,0.6)', margin: 0, fontSize: '0.8rem' }}>
                            {hasData ? `${this.state.FilterData.length.toLocaleString('en-US')} items loaded` : 'Select a start and end date to view purchase order history'}
                        </p>
                    </div>
                </div>

                <div style={{ padding: '1.5rem 2rem' }}>

                    {/* Date Range + Load + Excel */}
                    <div className="card mb-3" style={{ borderRadius: '12px', border: '1px solid #E2E8F0', overflow: 'hidden' }}>
                        <div style={{ background: 'linear-gradient(135deg, #0f172a 0%, #1e3a8a 100%)', padding: '0.75rem 1.25rem' }}>
                            <span style={{ color: 'white', fontWeight: 700, fontSize: '0.8125rem' }}>Date Range</span>
                        </div>
                        <div className="card-body">
                            <div className="row g-3 align-items-end">
                                <div className="col-sm-12 col-md-3">
                                    <label style={labelStyle} htmlFor="startPurchaseHistoryDate">Start Date</label>
                                    <input style={inputStyle} id='startPurchaseHistoryDate' type="date" />
                                </div>
                                <div className="col-sm-12 col-md-3">
                                    <label style={labelStyle} htmlFor="endPurchaseHistoryDate">End Date</label>
                                    <input style={inputStyle} id='endPurchaseHistoryDate' type="date" />
                                </div>
                                <div className="col-sm-12 col-md-3">
                                    <button onClick={() => this.getPurchaseOrderHistory()} type="button"
                                        style={{ background: 'linear-gradient(135deg, #0f172a 0%, #1e3a8a 100%)', color: 'white', border: 'none', borderRadius: '8px', padding: '0.45rem 1.25rem', fontWeight: 700, fontSize: '0.875rem', cursor: 'pointer', display: 'inline-flex', alignItems: 'center', gap: '0.4rem', width: '100%', justifyContent: 'center' }}>
                                        <AiOutlineReload /> Load Data
                                    </button>
                                </div>
                                {hasData && (
                                    <div className="col-sm-12 col-md-3 d-flex justify-content-end">
                                        <ExcelDocument
                                            hidden={this.state.Data.length === 0}
                                            archname={'History Purchase Orders' + getValueCookie('Company') + ' ' + getDateFromReports()}
                                            sheetname2={['All Data History Purchase Orders ' + getValueCookie('Company')]}
                                            sheetname={'History Purchase Orders ' + getValueCookie('Company')}
                                            data={getDataSetHistoryPO(this.state.HeadTable, this.state.FilterData, this.state.Totals)}
                                            data2={[getDataSet(this.state.NotProcessData, ["OrderNo", "OrderDate", "VendorNo", "VendorName", "ItemCode", "QuantityOrdered", "QuantityReceived", "UnitCost", "OriginalUnitCost", "Status"], ["OrderNo", "OrderDate", "VendorNo", "VendorName", "ItemCode", "QuantityOrdered", "QuantityReceived", "UnitCost", "OriginalUnitCost", "Status"])]}
                                        />
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>

                    {/* Purchase order history table */}
                    <div hidden={this.state.Data.length === 0} className='card' style={{ borderRadius: '12px', border: '1px solid #E2E8F0', overflow: 'hidden' }}>
                        <div style={{ background: 'linear-gradient(135deg, #0f172a 0%, #1e3a8a 100%)', padding: '0.75rem 1.25rem', display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: '0.75rem' }}>
                            <span style={{ color: 'white', fontWeight: 700, fontSize: '0.8125rem' }}>Purchase Order Detail</span>
                            <div style={{ position: 'relative', minWidth: '240px', flex: '1 1 260px', maxWidth: '420px' }}>
                                <AiOutlineSearch style={{ position: 'absolute', left: '10px', top: '50%', transform: 'translateY(-50%)', color: 'rgba(255,255,255,0.5)', fontSize: '1rem' }} />
                                <input onChange={this.searchHistoryPO} type="text" autoComplete='off' id='searchPurchaseHistoryDate'
                                    placeholder='Search Item by ItemCode, Line Product, Description...'
                                    style={{ background: 'rgba(255,255,255,0.12)', border: '1px solid rgba(255,255,255,0.2)', borderRadius: '8px', color: 'white', fontSize: '0.8125rem', padding: '0.35rem 0.75rem 0.35rem 2rem', width: '100%', outline: 'none' }}
                                />
                            </div>
                        </div>
                        <div className='card-body p-0'>
                            <div className='tableFixHead'>
                                <table className="table align-middle table-hover mb-0">
                                    <thead className='text-center'>
                                        <tr>
                                            <th style={{ background: '#0f172a', color: 'white', border: 'none' }} colSpan={8}></th>
                                            {this.state.HeadTable.Year.map((element, e) => (
                                                <th style={{ background: '#0f172a', color: 'white', border: 'none', fontWeight: 800 }} key={uuidv4()} colSpan={element.SpanCol}>{element.Year}</th>
                                            ))}
                                        </tr>
                                        <tr>
                                            <th style={{ background: '#1e3a8a', color: 'white', border: 'none' }} colSpan={8}></th>
                                            {this.state.HeadTable.Months.map((element, e) => (
                                                <th style={{ background: '#1e3a8a', color: 'white', border: 'none', fontWeight: 700, fontSize: '0.85rem' }} key={uuidv4()} colSpan={element.SpanCol}>{element.Month}</th>
                                            ))}
                                        </tr>
                                        <tr>
                                            <th style={{ background: '#1e293b', color: 'rgba(255,255,255,0.85)', border: 'none' }} colSpan={8}></th>
                                            {this.state.HeadTable.Dates.map((element, e) => (
                                                <th colSpan={2} style={{ background: '#1e293b', color: 'rgba(255,255,255,0.85)', border: 'none', fontWeight: 700, fontSize: '0.8rem' }} key={uuidv4()} >{element.Date}</th>
                                            ))}
                                        </tr>
                                        <tr>
                                            {this.state.HeadTable.GeneralHeaders.map((element, e) => (
                                                e <= 3 ?
                                                    <>
                                                        <th colSpan={2} key={uuidv4()} style={{ background: '#334155', color: 'white', border: 'none' }} >
                                                            <div className='row'><div className='col-12'></div><div className='col-12'></div></div>
                                                        </th>
                                                    </>
                                                    :
                                                    <th colSpan={2} key={uuidv4()} onClick={() => this.SelectOrderInHistory(this.state.FilterData, element.OrderNo, this.state.order)} style={{ background: '#334155', color: 'white', border: 'none', cursor: 'pointer', fontWeight: 700, fontSize: '0.8rem' }} >
                                                        <div className='row'><div className='col-12'>{element.OrderNo}</div><div className='col-12'>{element.Comment}</div></div>
                                                    </th>

                                            ))}
                                        </tr>
                                        <tr>
                                            {this.state.HeadTable.GeneralHeaders.map((element, e) => (
                                                e <= 3 ?
                                                    <>
                                                        <th colSpan={2} key={uuidv4()} onClick={() => this.SelectOrderInHistory(this.state.FilterData, element.OrderNo, this.state.order,"")} style={{ background: '#475569', color: 'white', border: 'none', cursor: 'pointer', fontWeight: 700, fontSize: '0.78rem' }} >
                                                            <div className='row'><div className='col-12'>{element.OrderNo + element.Comment}</div><div className='col-12'><BsFileArrowUpFill className='fs-mini' /><BsFileArrowDownFill className='fs-mini' /></div></div>
                                                        </th>
                                                    </>
                                                    :
                                                    <>
                                                        <th key={uuidv4()} onClick={() => this.SelectOrderInHistory(this.state.FilterData, element.OrderNo, this.state.order,"QuantityOrdered")} style={{ background: '#475569', color: 'white', border: 'none', cursor: 'pointer', fontWeight: 700, fontSize: '0.78rem' }} >
                                                            <div className='row'><div className='col-12'>{"Quantity\nOrdered"}</div><div className='col-12'><BsFileArrowUpFill className='fs-mini' /><BsFileArrowDownFill className='fs-mini' /></div></div>
                                                        </th>
                                                        <th key={uuidv4()} onClick={() => this.SelectOrderInHistory(this.state.FilterData, element.OrderNo, this.state.order,"QuantityReceived")} style={{ background: '#475569', color: 'white', border: 'none', cursor: 'pointer', fontWeight: 700, fontSize: '0.78rem' }} >
                                                            <div className='row'><div className='col-12'>{"Quantity\nReceived"}</div><div className='col-12'><BsFileArrowUpFill className='fs-mini' /><BsFileArrowDownFill className='fs-mini' /></div></div>
                                                        </th>
                                                    </>


                                            ))}
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {this.state.FilterData.map((element, e) => (
                                            <tr key={uuidv4()}>
                                                <td colSpan={2} className='text-start'>{element.ItemCode}</td>
                                                <td colSpan={2} className='text-start'>{element.Description}</td>
                                                <td colSpan={2} className='text-start'>{element.VendorName}</td>
                                                <td colSpan={2} className='text-start'>{element.ProductLine}</td>
                                                {element.Detail.map((orders, o) => (
                                                    <>
                                                        <td key={uuidv4()} className='text-center'>{(!(orders.QuantityOrdered) && orders.QuantityOrdered !== 0) ? '0' : (orders.QuantityOrdered === -1 ? '0' : orders.QuantityOrdered)}</td>
                                                        <td key={uuidv4()} className='text-center'>{(!(orders.QuantityReceived) && orders.QuantityReceived !== 0) ? '0' : (orders.QuantityReceived === -1 ? '0' : orders.QuantityReceived)}</td>
                                                    </>
                                                ))}
                                            </tr>
                                        ))}
                                    </tbody>
                                    <tfoot className='tfoot'>
                                        <tr className='bg-dark text-white'>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td className='text-center fw-bold'>TOTALS</td>
                                            {this.state.Totals.map((total, t) => (
                                                <td className='text-center fw-bold' key={uuidv4()}>{total.Total}</td>
                                            ))}
                                        </tr>

                                    </tfoot>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        )
    }

}